import React from 'react';
import { Icon } from '../../../../concepts/resources/Icon';
import { Menu } from '../../../../ui';
import { useEditorSessionObserver } from '../../../canvas/EditorSession';
import { Selection } from '../../../canvas/Selection';
import { PopoutWidget } from '../../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../../dashboard/elements/LayoutElements';
import { JiraCard } from '../JiraCard';
import { SetJiraSprintForCardsMenu } from '../menus/JiraSprintMenu';
import { JiraAssigneeMenu } from './JiraAssigneeField';
import { JiraIssueTypeMenu } from './JiraIssueTypeField';
import { JiraOAuthRequired } from './JiraOAuthRequired';
import { JiraPriorityMenu } from './JiraPriorityField';
import { JiraStatusMenu } from './JiraStatusField';

const SubMenuFromMenu = (Original: React.ComponentType<{ cards: JiraCard[], onClose(): void }>) =>
    () => {
        const selection = useEditorSessionObserver(Selection);
        const cards = selection.polarize(JiraCard);
        if (!cards.length) return null;

        return <Original cards={cards} onClose={() => { }} />;
    };

const JiraAssigneeSubMenu = SubMenuFromMenu(JiraAssigneeMenu);
const JiraPrioritySubMenu = SubMenuFromMenu(JiraPriorityMenu);
const JiraIssueTypeSubMenu = SubMenuFromMenu(JiraIssueTypeMenu);
const JiraStatusSubMenu = SubMenuFromMenu(JiraStatusMenu);
const JiraSprintSubMenu = SubMenuFromMenu(SetJiraSprintForCardsMenu);

export const JiraBulkChangeMenu = ({ widget }: { widget: PopoutWidget }) => {
    const onReject = () => widget.update({ open: false });
    return <JiraOAuthRequired onReject={onReject}>
        <Flexer minWidth="12">
            <Menu>
                <Menu.Section title="Bulk Actions:" first>
                    <Menu.SubMenuItem menu={JiraAssigneeSubMenu}>
                        <Icon src="deqo://icons/hero/user" size="1.25" />
                        Assign
                    </Menu.SubMenuItem>
                    <Menu.SubMenuItem menu={JiraPrioritySubMenu}>
                        <Icon src="deqo://icons/hero/exclamation" size="1.25" />
                        Change Priority
                    </Menu.SubMenuItem>
                    <Menu.SubMenuItem menu={JiraIssueTypeSubMenu}>
                        <Icon src="deqo://icons/hero/ticket" size="1.25" />
                        Change Issue Type
                    </Menu.SubMenuItem>
                    <Menu.SubMenuItem menu={JiraSprintSubMenu}>
                        <Icon src="deqo://icons/jira/sprint" size="1.25" />
                        Change Sprint
                    </Menu.SubMenuItem>
                    <Menu.SubMenuItem menu={JiraStatusSubMenu}>
                        <Icon src="deqo://icons/hero/arrow-right" size="1.25" />
                        Transition
                    </Menu.SubMenuItem>
                </Menu.Section>
            </Menu>
        </Flexer>
    </JiraOAuthRequired>;
};
